<template>
  <div class="row projectForm">
    <div v-if="modalForm.isEmptyDiv">
      <div class="row">
        <div class="col-12" style="border-bottom: 1px solid #f3f3f3;">
          <h4>Information</h4>
        </div>
        <div class="col-12 mt-2" style="font-size: 18px">
          <font-awesome-icon icon="check" color="#538c79" size="lg" class="icon"/>
          <span class="mx-2">İzin var</span>
          <font-awesome-icon icon="times" color="#b66666" size="lg" class="icon"/>
          <span class="mx-2">İzin yok</span>
        </div>
      </div>
    </div>
    <div v-if="modalForm.isActiveProjectModal" class="border rounded-4 mx-lg-2" style="padding: 10px">
      <div v-if="projectForm.projectId != null" class="row" style="padding: 5px;">
        <div class="col-10">
          <h5>Edit Project / {{projectForm.projectName}}</h5>
        </div>
        <div class="col-2 text-end" style="cursor: pointer">
          <font-awesome-icon @click="goToDetails(projectForm.projectId,projectForm.projectName,projectForm.projectCode)" icon="cog"
                             size="lg" style="margin-left:5px" color="#1e3e67" class="icon"
          />
        </div>
      </div>
      <div v-else style="padding: 5px;">
        <h5>Add Project</h5>
      </div>
      <div class="pt-2" style="border-top: 1px solid #f3f3f3;padding: 10px">
        <label class="form-label">Project Name</label>
        <div class="input-group">
          <input type="hidden" v-model="projectForm.projectId">
          <input v-model="projectForm.projectName" class="form-control" required maxlength="50">
          <input v-model="projectForm.projectId" class="form-control" required maxlength="50">
        </div>
        <label class="form-label pt-2">Project Code</label>
        <div class="input-group">
          <input v-model="projectForm.projectCode" class="form-control" required maxlength="50">
        </div>
        <label class="form-label pt-2">Project Main Route</label>
        <div class="input-group">
          <input  v-model="projectForm.projectMainRoute" class="form-control" required
                  maxlength="200">
        </div>
        <label class="form-label pt-2">Project Description</label>
        <textarea v-model="projectForm.projectDescription" class="form-control" rows="3" style="resize: none;"></textarea>
        <div class="form-check pt-2">
          <label class="form-check-label">
            <input type="checkbox" v-model="projectForm.usesSingleSignOn" class="form-check-input">
            This project use <strong>Single Sign On</strong>
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" v-model="projectForm.isPrivate" class="form-check-input">
            This project is <strong>Private</strong>
          </label>
        </div>
        <label class="form-label pt-4">To Upload Project Icon</label>
        <div style="cursor: pointer" v-if="(projectForm.projectCode != '')">
          <file-pond name="file"
                     id="FilePoundUpload"
                     ref="pond4"
                     label-idle="Select Icon"
                     :files="file"
                     :server="fileUploadLocalServer"
                     :instant-upload="true"
                     :drop-on-page="true"
                     :allow-multiple="false"
                     credits="false"
                     :allowFileRename="true"
                     :disabled="projectForm.projectCode == ''"
                     accepted-file-types="image/jpg,image/jpeg, image/png"
          />
        </div>



        <div class="alert alert-danger alert-error" role="alert" v-if="projectForm.projectCode == ''">
          <span> You need to declare project code before uploading to project icon.</span>
        </div>
        <div v-if="projectForm.projectId != null" class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
          <button class="btn btn-success mt-3" @click="TryAddProject(projectForm)">
            <font-awesome-icon icon="edit"/>
            <span class="mx-1">Update</span>
          </button>
        </div>
        <div v-else class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
          <button class="btn mt-2" @click="TryAddProject(projectForm)" style="background-color: #56759c;color: #ffffff">
            <font-awesome-icon icon="save"/>
            <span class="mx-1">Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";


// Import plugins
import vueFilePond, {setOptions} from 'vue-filepond';
import FilePondPluginFileValidateType
  from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview,FilePondPluginFileRename);

import ProjectsService from "../../services/projects.service";

const {mapActions} = createNamespacedHelpers('projects');

export default {
  name: "SideForm",
  props: ["projectForm", "modalForm"],
  components:{
    FilePond,
  },
  data(){
    return{
      file: "",
      icon:"",
      fileUploadLocalServer: {
        process: (fieldName, file, metadata, load) => {
          (async () => {
            try {
              this.icon = file;
              console.log(this.icon)
              load();
            } catch (e) {
              this.$notify({title: 'Error', text: e.message, type: "error", duration: "15000"});
            }
          })();
        },
      },
    };

  },
  methods: {
    ...mapActions(["addProject","uploadIcon"]),

    async TryAddProject(value) {
      try {
        console.log(this.icon)
        await ProjectsService.uploadIconService({
          files: this.icon,
        });
        await this.addProject(value);
        this.$notify({title: "Success", type: "success", text: "Project succesfully adding."})
      } catch (e) {
        this.$notify({title: "Error", type: "error", text: e})
      }finally {
        //this.getProjects();
      }
    },
    async goToDetails(value, name,code) {
      this.$router.push({
        name: 'ProjectDetails',
        params: {selectedProjectId: parseInt(value), selectedProjectName: name,selectedProjectCode : code}
      });
    },

  },
  created() {
    setOptions({
      fileRenameFunction: (file) => {
        if( file.extension == '.jpeg' || file.extension == '.jpg'){
          return this.projectForm.projectCode+`.png`;
        }else
          return this.projectForm.projectCode+`${file.extension}`;
      },
    });

  },
}
</script>

<style>
.filepond--drop-label label {
  cursor: pointer;
  color: black;
}
.filepond--file-info .filepond--file-info-main {
  overflow: unset;
}
.filepond--drop-label {
  background: #eef2f5 !important;
}

.alert.alert-danger.alert-error {
  background: url(../../assets/images/alert.jpg);
  box-shadow: 0 0 4px #525252;
  border-radius: 3px;
  line-height: 20px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right;
  border: none;
}
.alertHeader {
  font-size: 18px;
  padding-bottom: 10px;
  color: #ffffff;
  text-align: start;
  font-weight: 500;
}
.alert.alert-error.alert-danger span {
  display: block;
  font-size: 14px;
  padding: 5px 0;
  background-color: #ffffff33;
  border-radius: 5px;
  padding-left: 15px !important;
  color: #ffffff;
  text-align: start;
}


</style>
